
export const rulesReducer = (state = [], action) => {

    switch (action.type) {
        case '[RULES] Load validators':
            return {
                ...state,
                validators: action.payload
            }

        default:
            return state
    }


}